import { formatDate, getCurrentTime, parseDate } from '../../domain/utils/date'
import { createCustomSelector } from '../../domain/utils/react-reselect'
import { selectItineraryState } from './itinerary.selectors'

export const selectRoadbookSummary = createCustomSelector(selectItineraryState, ({ roadbook }) => {
  if (!roadbook || !roadbook.summary) return {}
  const summary = roadbook.summary
  const arrivalDate = parseDate(summary?.arrival_datetime)
  const departureDate = parseDate(summary?.departure_datetime)

  return {
    duration: summary?.duration?.label,
    distance: summary?.length?.label,
    distanceInMeter: summary?.length?.value,
    gas: {
      label: summary?.prices?.gas?.label,
      value: summary?.prices?.gas?.value,
    },
    toll: {
      label: summary?.prices?.toll?.label,
      value: summary?.prices?.toll?.value,
    },
    departureTimeLabel: {
      day: formatDate(departureDate),
      hour: getCurrentTime(departureDate),
    },
    arrivalTimeLabel: {
      day: formatDate(arrivalDate),
      hour: getCurrentTime(arrivalDate),
    },
  }
})
